import { render, staticRenderFns } from "./OrdersNewView.vue?vue&type=template&id=38e91ad6"
import script from "./OrdersNewView.vue?vue&type=script&lang=js"
export * from "./OrdersNewView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports